export const inputClass = 'w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100'
export const labelClass = 'mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500'

export function clean(payload) {
  return Object.fromEntries(Object.entries(payload).map(([key, value]) => [key, value === '' ? null : value]))
}

export function Field({ label, children }) {
  return <label><span className={labelClass}>{label}</span>{children}</label>
}

export function Text({ label, value, onChange, type = 'text', placeholder = '' }) {
  return <Field label={label}><input type={type} value={value ?? ''} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className={inputClass} /></Field>
}

export function Area({ label, value, onChange, rows = 3 }) {
  return <Field label={label}><textarea value={value ?? ''} onChange={(e) => onChange(e.target.value)} rows={rows} className={inputClass} /></Field>
}

export function Select({ label, value, onChange, children }) {
  return <Field label={label}><select value={value ?? ''} onChange={(e) => onChange(e.target.value)} className={inputClass}>{children}</select></Field>
}

export function Card({ children }) {
  return <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">{children}</div>
}

export function Row({ title, subtitle, onEdit }) {
  return <button type="button" onClick={onEdit} className="w-full rounded-xl border border-slate-200 p-3 text-left transition hover:border-blue-300 hover:bg-blue-50/40"><div className="font-medium text-slate-900">{title || 'Untitled'}</div><div className="mt-1 text-xs text-slate-500">{subtitle || 'Click to edit'}</div></button>
}

export function Actions({ saving, editing, reset }) {
  return <div className="flex gap-2 md:col-span-2"><button disabled={saving} className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50">{saving ? 'Saving...' : editing ? 'Save changes' : 'Add record'}</button>{editing ? <button type="button" onClick={reset} className="rounded-lg border border-slate-300 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50">Cancel edit</button> : null}</div>
}

export function TwoColumn({ title, rows, renderRow, children }) {
  return <div className="grid grid-cols-1 gap-5 xl:grid-cols-[1fr_1.2fr]"><Card><div className="mb-4 flex items-center justify-between"><h3 className="text-lg font-semibold text-slate-900">{title}</h3><span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-600">{rows.length}</span></div><div className="max-h-[650px] space-y-2 overflow-y-auto">{rows.length ? rows.map(renderRow) : <div className="rounded-lg border border-dashed border-slate-300 p-8 text-center text-sm text-slate-500">No records yet</div>}</div></Card><Card><h3 className="mb-4 text-lg font-semibold text-slate-900">Add / edit</h3>{children}</Card></div>
}